<template>
    <v-container container--fluid class="mb-6">
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Receipts</h1>
                <v-card class="elevation-12">
                    <v-card-title>
                        Receipts List
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" clearable single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :search="search" :loading="ordersLoading" :sort-by="['p_date']" :sort-desc="[true]" must-sort :items-per-page="10" :headers="headers" :items="payments" item-key="p_id" class="elevation-1">
                        <template slot="item" slot-scope="props">
                            <tr>
                                <!-- <td><v-btn color="primary" :to="{name: 'orderDetail', params: {order_id: props.item.o_id}}">View<v-icon right medium>visibility</v-icon></v-btn> #{{ props.item.p_id }}</td> -->
                                <td><v-btn color="primary" :to="{name: 'orderDetail', params: {'order_id': props.item.o_id, 'typeorig': orig}}">View<v-icon right medium>visibility</v-icon></v-btn></td>
                                <td class="text-left">{{ props.item.p_date | moment("DD/MM/YYYY hh:mm a")}}</td>
                                <td class="text-left"><span v-html="props.item.p_description"></span></td>
                                <td class="text-left">{{ props.item.p_status | capitalize }}</td>
                                <td class="text-right">{{ props.item.p_amount | currency }}</td>
                                <!-- <td class="justify-end align-center layout">
                                    <v-btn color="primary" :to="{name: 'orderDetail', params: {order_id: props.item.o_id}}">View <v-icon right medium>visibility</v-icon></v-btn>
                                </td> -->
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Receipts Yet
                            </div>
                        </template>
                        <template slot="no-results">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Results found for "{{ search }}"
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from './_store';

export default {
    name: 'OrderModule',
    props: ['orig'],
    components: {
        //
    },
    data () {
        return {
            search: '',
            headers: [
                { text: '#', value: 'p_id', sortable: false},
                { text: 'Date', value: 'p_date' },
                { text: 'Description', value: 'p_description', sortable: false },
                { text: 'Status', value: 'p_status' },
                { text: 'Amount', align: 'right', value: 'p_amount', sortable: false },
            ],
        }
    },
    computed: {
        ordersLoading(){
            return this.$store.getters['order/orderStatus'] == 'loading';
        },
        orders(){
            return this.$store.getters['order/orders'];
        },
        payments(){
            return this.$store.getters['order/payments'];
        },
    },
    methods: {
    },
    beforeCreate(){
        // this.$store.dispatch('user/userRequest');
        // if(_.isEmpty(this.$store.getters['order/orders'])){
            this.$store.commit("order/RESET_STATE");
            // this.$store.dispatch('order/orderRequest', {'orig': this.$options.propsData.orig});
            this.$store.dispatch('order/paymentRequest', {'orig': this.$options.propsData.orig});
        // }
    }
};
</script>

<style scoped>
    .v-data-table td {
        height: 58px !important;
    }
</style>
